import React from 'react';
import { SectionHeader, Card } from '../../components';

const ValuesSection = () => {
  const values = [
    {
      icon: 'fas fa-heart',
      title: 'Client-Centric',
      description: 'We put our clients first, understanding their unique needs and delivering solutions that exceed expectations.'
    },
    {
      icon: 'fas fa-handshake',
      title: 'Collaboration',
      description: 'We believe in the power of teamwork and foster strong partnerships with our clients and team members.'
    },
    {
      icon: 'fas fa-lightbulb',
      title: 'Innovation',
      description: 'We stay ahead of industry trends and leverage cutting-edge technology to deliver innovative solutions.'
    }
  ];

  return (
    <section className="section-padding bg-light">
      <div className="container">
        <SectionHeader
          subtitle="Our Values"
          title="Mission, Vision & Values"
          description="The principles that guide everything we do"
        />
        <div className="row">
          {values.map((value, index) => (
            <div key={index} className="col-lg-4 col-md-6 mb-4">
              <Card
                icon={value.icon}
                title={value.title}
                description={value.description}
                animationDelay={index * 100}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
